// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

// 引入mint-ui
import Mint from 'mint-ui';
Vue.use(Mint);
import 'mint-ui/lib/style.css';

import './assets/sass/reset.css'

import api from './http/api'
import Router from "vue-router"; // 导入api接口
import { isIos,cdnUrl } from '@/utils';
Vue.prototype.$isIos = isIos();
Vue.prototype.$cdnUrl = cdnUrl;
Vue.prototype.$api = api;    // 将api挂载到vue的原型上复制代码

// 打开新长乐app协议
Vue.prototype.$openApp = 'tuiqiu://';
Vue.prototype.$openApp2 = 'yhcaidian://';
// 打开指定页面 及 参数
// tuiqiu://bet?stateParams={"returnUrl":returnUrl}&stateName=LoginPage

// 部署地址
Vue.prototype.$webUrl = process.env.WEB_URL;

Vue.config.productionTip = false;
router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    from.name ? next({
      name: from.name
    }) : next('/errorPage');
  } else {
    next(); //如果匹配到正确跳转
  }
});



router.afterEach( ( to, from, next ) => {
  window._hmt.push(['_setAutoPageview', false]);
  if (to.path) {
    window._hmt.push(['_trackPageview', to.fullPath]);
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js